import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export function TranslatingTableTitles(titles) {
  let translatedTableTitles = [];
  for (let i = 0; i < titles.length; i++) {
    const value = {
      key: titles[i].key,
      label: i18n.t(titles[i].label),
      sorter: titles[i].sorter,
      filter: titles[i].filter,
      _style: titles[i]._style,
    };

    translatedTableTitles.push(value);
  }
  return translatedTableTitles;
}

export function I18nUse2(resources) {
  return i18n.use(initReactI18next).init({
    resources,
  });
}

export function I18nUse() {
  return i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: {
          日本語: 'English',
          ログイン: 'Sign in',
          パスワードを忘れたかたはこちら: 'Forget your password?',
          取引支援システム: 'Trading support system',
          ユーザID: 'User ID',
          パスワード: 'Password',
          キャンセル: 'Cancel',
          データなし: 'No data',
          自然電力: 'Natural electricity',
          閉じる: 'Close',
          '当機能を利用する権限がありません。': 'You do not have permission to use this function.',
          '当サイトの利用権限がありません':'You do not have permission to access this site',
          '失敗しました。': 'An error has occurred.',

          //area
          北海道: 'Hokkaido',
          東北: 'Tohoku',
          東京: 'Tokyo',
          中部: 'Chubu',
          北陸: 'Hokuriku',
          関西: 'Kansai',
          中国: 'Chugoku',
          四国: 'Shikoku',
          九州: 'Kyushu',

          //merchandise-type
          MMS1000: 'EPRX1',
          MMS2100: 'EPRX2-1',
          MMS2200: 'EPRX2-2',
          MMS3100: 'EPRX3-1',
          MMS3200: 'EPRX3-2',
          //TO-DO
          タスク: 'Task',
          期限: 'Deadline',
          ステータス: 'Status',
          メッセージ: 'Message',
          日次タスク: 'Daily tasks',
          実需給向け: 'Actual balancing for',
          //サイト情報
          サイト情報表示: 'Site information',
          サイト情報表示画面: 'Site information display screen',
          集計単位: 'Aggregation unit',
          事業者: 'Business',
          サイト: 'Site',
          適用: 'Apply',
          集計期間: 'Aggregation period',
          スポット売電: 'Day ahead sell',
          時間前売電: 'Intraday sell',
          発電インバランス料: 'Imbalance sell',
          '需給調整市場 ': 'Balancing',
          電力調達費: 'Procurement cost',
          その他: 'Other',
          '合計 ': 'Total',
          '年間見込み(円)': 'Annual forecast(JPY)',
          '表面利回り(%)': 'Surface yield(%)',
          'スポット売電(円)': 'Day ahead sell(JPY)',
          '発電インバランス料(円)': 'Imbalance sell(JPY)',
          '需給調整市場(円)': 'Balancing(JPY)',
          '電力調達費(円)': 'Procurement cost(JPY)',
          'その他(円)': 'Other(JPY)',
          '合計(円)': 'Total(JPY)',
          '時間前売電(円)': 'Intraday sell(JPY)',
          '事業者IRR(%)': 'IRR(%)',
          表示件数: 'Displayed results',
          件: ' items',
          //取引実績取得
          取引実績取得: 'Transaction results',
          'ダウンロードに失敗しました。': 'Download failed.',
          'ダウンロードに成功しました。': 'Download success.',
          '数分時間がかかりますが実行しますか？':
            'This may take a few minutes, but do you want to proceed?',
          取引実績ダウンロード: 'Transaction results download',
          '集計期間は1年以内を指定してください。':
            'Please specify the aggregation period within one year.',
          //入札対象外サイト指定画面
          入札対象外サイト指定画面: 'Designation of sites not eligible for bidding screen',
          の入札計画対象外サイト一覧: 'List of sites excluded from the bidding plan of',
          入札計画対象外サイト情報編集: 'Edit site information not subject to bidding plans',
          選択サイトの対象外情報を編集: 'Edit the excluded information of the selected site',
          属地エリア: 'Area',
          事業者名: 'Company name',
          サイト名: 'Site name',
          'サイト名  ': 'Site',
          対象外期間開始日: 'Excluded period start date',
          対象外期間終了日: 'Excluded period end date',

          解除: 'Delete',
          '未保存の編集内容があります。': 'There is edited content but it has not been saved.',
          破棄して閉じる: 'Discard and close',
          編集に戻る: 'Back to edit',
          入札計画対象外期間編集: 'Edit period outside of bidding plan',
          保存: 'Save',
          //インバランス予測単価
          インバランス予測単価: 'Imbalance prices',
          インバランス予測単価表示: 'Imbalance prices display',
          グラフ表示設定: 'Graph settings',
          '余剰IB単価（予測）': 'Forecast surplus imbalance prices',
          余剰IB単価: 'Surplus imbalance prices',
          エリアプライス: 'Area prices',
          表示範囲: 'Display period',
          "円/0.5h":"JPY/0.5h",
          //計画一覧
          計画一覧: 'Plan list',
          '計算を開始しました。数分待ってから入札計画一覧のステータスを確認してください。':
            'Calculation has been started. Please wait a few minutes and check the status on your bid plan list.',
          '入札計画を計算を開始してよいですか？': 'Do you want to start calculating the bid plan?',
          '入札計画を確定してよいですか？': 'Do you want to confirm the bid plan?',
          はい: 'Yes',
          いいえ: 'No',
          '計算を開始できませんでした。': 'Failed to start calculation.',
          単価補正: 'Unit price adjustment',
          スポット入札計画実行: 'Day ahead bidding plan execution',
          入札計画実行: 'Bidding plan execution',
          計画ダウンロード: 'Plan download',
          計画アップロード: 'Plan upload',
          電力需給日: 'Date',
          スポット市場単価: 'JEPX Spot',
          複合市場単価: 'EPRX Composite',
          '三次②市場単価': 'EPRX 3-2',
          'スポット市場\n約定単価': 'Day ahead market execution unit price',
          '需給調整市場三次②\n最高約定単価':
            'Tertiary-2 balancing market \n highest contract price',
          入札計画一覧: 'Bidding plan list',
          入札計画収益画面: 'Bid plan profit screen',
          "既存のエリア内計画は全て削除され、元に戻すことはできません。未計画にもどしますか？":"All existing plans within the area have been deleted and cannot be restored. Do you want to delete plans in area?",
          市場: 'Market',
          計画の収益確認と確定: 'Confirm and definite plan profit',
          計画対象日: 'Plan target date',
          エリア: 'Area',
          更新: 'Update',
          スポット入札計画確定: 'Confirm day ahead bidding plan',
          '三次②入札計画確定': 'Confirm tertiary-2 bidding plan',
          入札計画確定: 'Confirm bidding plan',
          入札しない: "Do not bid",
          未計画に戻す: "Delete plans in area",
          "エリアステータス：":"Area status:",
          サイト計画種別:"Site status",
          入札対象の変更を保存:"Save changes",
          "アップロードに成功しました。": "Upload successful.",
          "アップロードに失敗しました。": "Upload failed.",
          "エラーです。": " error.",
          "登録期限を過ぎたレコードがあります。": "There are records whose registration deadline has passed.",
          "48コマではない計画日があります。": "There is a planned date that is not 48 frames.",
          "スポット、三次②の両方に入札するコマがあります。":"There are frames to bid on both spot and tertiary ②.",
          "計画ファイルを読み込めませんでした。ファイル内容を再確認してください。":"Failed to load planned file. Please recheck the file contents.",
          "週間商品約定ブロックと重複する入札コマがあります。":"There are bid frames that overlap with weekly product contract blocks.",
          "三次②入札ブロック内の入札量・入札単価が、6コマで同一ではありません。":"The bid volume and bid price in the tertiary ② bid block are not the same for 6 frames.",
          "三次②入札単価が、エリア内で一意ではありません。":"The tertiary ② bid price is not unique within the area.",
          "三次②入札単価が、同じ日付で一意ではありません。": "Tertiary ② Bid unit price is not unique for the same date",
          "三次②入札コマの単価が不正です。":"The unit price of the tertiary ② bid frame is invalid.",
          "三次②入札コマの入札量が不正です。":"The bid volume of the tertiary ② bid frame is invalid.",
          "{0}が、入札計画対象外です。":"{0} is not included in the bid plan.",
          "{0}:入札計画対象外サイト":"{0}: Site not included in the bid plan",
          '{0}が、入札計画対象外です。\nーーーーーーーーーーーー\n{0}:入札計画対象外サイト': '{0} is not included in the bid plan.\nーーーーーーーーーーーー\n{0}: Site not included in the bid plan',
          "{0}が、テナント内に存在しません。":"{0} does not exist in the tenant.",
          "{0}:入札計画対象外サイトID":"{0}: Site ID not included in the bidding plan",
          '{0}が、テナント内に存在しません。\nーーーーーーーーーーーー\n{0}:入札計画対象外サイトID': '{0} does not exist in the tenant.\nーーーーーーーーーーーー\n{0}: Site ID not included in the bidding plan',
          "修正後、再登録してください。": "Please correct the error and re-upload.",
          'スポット入札計画を確定しました。': 'The day ahead bidding plan has been finalized.',
          '三次②入札計画を確定しました。': 'Tertiary-2 bidding plan has been finalized.',
          '入札計画を確定しました。': 'The bidding plan has been finalized.',
          '{0}が、入札計画対象外です。\nーーーーーーーーーーーー\n{0}:入札計画対象外サイトID': '{0} is not included in the bid plan.\nーーーーーーーーーーーー\n{0}: Site ID not included in the bidding plan',
          '「入札計画確定」または「入札しない」ステータスのエリアに属するサイトIDが指定されました。「未計画」にしたあとで、再度計画ファイルをアップロードしてください。':'The site ID specified belongs to an area with a status of "Bid plan confirmed" or "Do not bid". Please change the status to "Not planned" and then upload the plan file again.',
          '同じコマでスポットの売りと買いはできません。': 'You cannot buy and sell spots on the same frame.',
          '同じコマで受電と逆潮はできません。': 'Receiving and reverse current cannot be done on the same frame.',
          入札対象: 'Bid',
          オーナー: 'Owner',
          サイト: 'Site',
          '予測総発電量\n(kWh)': 'Generation\nforecast\n(kWh)',
          '予測発電量\n(kWh)': 'Generation\nforecast\n(kWh)',
          スポット市場: 'Day ahead market',
          需給調整市場: 'Balancing market',
          '合計\n(円)': 'Total\n(JPY)',
          '総売電量\n(kWh)': 'Total electricity sales\n(kWh)',
          '総買電量\n(kWh)': 'Total electricity purchase amount\n(kWh)',
          '収益\n(円)': 'Profit\n(JPY)',
          '複合\n発動量期待値\n(kWh)': 'Comp\nexpected activation value\n(kWh)',
          '二次①\n発動量期待値\n(kWh)': 'Secondary-1\nexpected activation value\n(kWh)',
          '二次②\n発動量期待値\n(kWh)': 'Secondary-2\nexpected activation value\n(kWh)',
          '複合\n約定収益\n(円)': 'Comp\nexpected profit\n(JPY)',
          '一次\n約定収益\n(円)': 'Primary\nexpected profit\n(JPY)',
          '二次②\n期待利益\n(円)': 'Secondary-2\nexpected profit\n(JPY)',
          '三次①\n発動量期待値\n(kWh)': 'Tertiary-1\nexpected activation value\n(kWh)',
          '三次②\n発動量期待値\n(kWh)': 'Tertiary-2\nexpected activation value\n(kWh)',
          '合計\n発動量期待値\n(kWh)': 'Expected total\nactivation value\n(kWh)',
          '三次①\n期待利益\n(円)': 'Tertiary-1\nexpected profit\n(JPY)',
          '三次②\n期待利益\n(円)': 'Tertiary-2\nexpected profit\n(JPY)',
          '合計\n期待利益\n(円)': 'Total\nexpected profit\n(JPY)',
          合計: 'Total',
          '確定しました。アウトプットフォルダで入札用ファイルを確認してください。':
            'Confirmed. Please check the bidding file in the output folder.',
          '入札計画の確定に失敗しました。': 'Failed to finalize the bidding plan.',
          '入札計画の確定に成功しました。': 'The bidding plan was successfully finalized.',
          入札計画内訳: 'Bid plan detail',
          開始時刻: 'Start time',
          '電池残量\n(kWh)': 'Remaining\nenergy\n(kWh)',
          'スポット\n買電量\n(kWh)': 'Buys\nfrom jepx\n(kWh)',
          'スポット\n売電量\n(kWh)': 'Sells\nto jepx\n(kWh)',
          '受電点買電量\n(制御計画)\n(kWh)': 'Buys\nfor control plan\n(kWh)',
          '受電点売電量\n(制御計画)\n(kWh)': 'Sells\nfor control plan\n(kWh)',
          '充電量\n(kWh)': 'Charges\n(kWh)',
          '放電量\n(kWh)': 'Discharges\n(kWh)',
          'スポット\n利益\n(円)': 'Day ahead\nprofit\n(JPY)',
          '一次\n売電量\n(ΔkW)': 'Primary power\nsales amount\n(ΔkW)',
          '二次①\n売電量\n(ΔkW)': 'Secondary-1 power\nsales amount\n(ΔkW)',
          '二次②\n売電量\n(ΔkW)': 'Secondary-2 power\nsales amount\n(ΔkW)',
          '三次①\n売電量\n(ΔkW)': 'Tertiary-1 power\nsales amount\n(ΔkW)',
          '三次②\n売電量\n(ΔkW)': 'Tertiary-2 power\nsales amount\n(ΔkW)',
          '二次②期待利益 (円)': 'Secondary-2 expected profit (JPY)',
          '三次①\n期待利益\n(円)': 'Tertiary-1\nexpected profit\n(JPY)',
          '三次②\n期待利益\n(円)': 'Tertiary-2\nexpected profit\n(JPY)',
          '複合期待利益\n(円)': 'Comp\nprofit\n(JPY)',
          '一次約\n定利益\n(円)': 'Primary\nprofit\n(JPY)',
          '二次①\n期待利益\n(円)': 'Secondary-1\nexpected profit\n(JPY)',
          '二次②\n期待利益\n(円)': 'Secondary-2\nexpected profit\n(JPY)',
          //単価補正画面
          単価補正画面: 'Unit price correction screen',
          '取込成功しました。': 'The import was successful.',
          '保存成功しました。': 'The save was successful.',
          '補正単価が保存されていません。': 'Adjusted unit price has not been saved.',
          '入札可能時間帯が保存されていません。': 'Bidding time slot has not been saved.',
          '入札可能時間更新に成功しました。': 'Bidding time slots updated successfully.',
          '入札可能時間更新に失敗しました。': 'Failed to update bidding time slots.',
          卸市場補正: 'Wholesale market correction',
          需給調整市場補正: 'Balancing market correction',
          単価表示期間: 'Unit price display duration',
          '30分': '30 minutes',
          '3時間': '3 hours',
          '1日': '1 day',
          '1週': '1 week',
          '1ヶ月': '1 month',
          スポット市場グラフ設定: 'Day ahead graph settings',
          約定単価: 'Contract unit price',
          予測計算単価: 'Predicted calculation unit price',
          デフォルト単価: 'Default unit price',
          補正単価: 'Adjust unit price',
          '三次②グラフ設定': 'Tertiary-2 graph settings',
          '複合商品グラフ設定': 'Composite graph settings',
          '需給調整市場三次②': 'Balancing market tertiary-2',
          '三次②市場': 'Tertiary-2 market',
          複合市場: 'Composite market',
          最高約定単価: 'Maximum contract price',
          スポット約定単価の補助線表示: 'Auxiliary line',
          昼間平均: 'Daytime average',
          夜間平均: 'Night average',
          ピーク平均: 'Peak average',
          '24時間平均': '24 hour average',
          高値: 'Highest price',
          安値: 'Lowest price',

          単価表示グラフ: 'Unit price display graph',
          スポット予測: 'Day ahead prediction',
          スポット約定: 'Day ahead execution',
          スポット手入力: 'Day ahead manual input',
          手入力単価: 'Manual input unit price',
          補正単価グラフ: 'Adjust unit price graph',
          補正単価グラフと入札可能時間帯: 'Adjust unit price graph and bidding time range',
          補正対象: 'Correction target',
          スポット: 'Day ahead',
          '三次②': 'Tertiary-2',
          '三次②商品': 'Tertiary-2 product',
          複合商品: 'Compiste product',
          最新予測単価取込: 'Incorporate the latest forecast unit price',
          補正単価をデフォルト単価でリセット:
            'Reset the corrected unit price to the default unit price',
          補正単価を予測単価でリセット: 'Reset the corrected unit price to the forecast unit price',
          CSVアップロード: 'Upload CSV',
          CSVダウンロード: 'Download CSV',
          補正単価保存: 'Save adjusted unit price',
          入札可能時間更新: 'Bidding time slot update',
          '96コマ一括': 'Edit all 96 frames add',
          '16ブロック一括': 'Edit all 16 blocks add',
          円追加で: 'JPY',
          線形補間入力: 'Linear interpolation',
          日付区切り線表示: 'Display date separator lines',

          //Mfa
          認証コード: 'Authentication code',
          送信: 'Send',

          // パスワード
          旧パスワード: 'Old password',
          新パスワード: 'New password',
          '新パスワード（再）': 'New password (again)',
          ユーザIDまたはパスワードが間違っています: 'User ID or password is not correct',
          初回ログインです初期仮パスワードを変更しなければなりません:
            'This is your first login. You must change your initial temporary password.',
          '初回ログインです。初期仮パスワードを変更しなければなりません。':
            'This is your first login. You must change your initial temporary password.',
          パスワード変更: 'Change password',
          'パスワード変更（初回ログイン）': 'Change password (first login)',
          パスワードリセット: 'Reset password',
          未入力項目があります: 'There are some items that have not been entered.',
          NewPasswordとConfirmPasswordが一致しません: 'The password confirmation does not match',
          '不正な状態です。ログインし直してください。': 'Invalid state. Please log in again.',
          'ご登録のメールアドレスに認証コードを送信しました。メールをご確認の上、認証コードを入力してください。':
            'A verification code has been sent to your registered email address. Please check your email and enter the code.',
          'ログイン失敗しました。入力値を確認した上再度行ってください。 \nそれでも失敗する場合は、キャンセルボタンを押してE-mailとPasswordの入力からやり直してください。':
            'Login failed. Please check your input and try again.\nIf the problem persists, press cancel and login again with your email and password.',
          有効なメールアドレスではありません: 'Invalid mail address',

          入力したパスワードが一致しません: 'Password is ummatched',
          'パスワードリセット失敗。入力値を確認した上再度行ってください':
            'Error occured. Please retry',
          'ログイン失敗しました。入力値を確認した上再度行ってください':
            'Login failed. Please check the input value and try again. ',
          'パスワード変更失敗。入力値を確認した上再度行ってください':
            'Password change failed. Please check the input value and try again.',
          '※パスワード太：大文字、小文字、入力、記号を8文字表':
            '* Password thick: 8 character table of uppercase letters, lowercase letters, input, and symbols ',
          '※パスワードポリシー：大文字、小文字、数値、記号を含む８文字以上':
            '* Password policy: 8 characters or more including uppercase letters, lowercase letters, numbers, and symbols ',
          変更: 'Change',
          リセット: 'Reset',
          // 単位
          '円/kW': 'JPY/kW',
          '円/年': 'JPY/annual',
          円: 'JPY',
          年: 'year',
          'kWh/日': 'kWh/day',
          '円/kWh': 'JPY/kWh',
          '円/ΔkW': 'JPY/ΔkW',
          '円/kWp': 'JPY/kWp',
          '円/kWp/年': 'JPY/kWp/annual',
          '円/台': 'JPY/Unit',
          '円/台/年': 'JPY/Unit/annual',
          '¥': 'JPY',
        },
      },
      ja: {
        translation: {
          //merchandise-type
          MMS1000: '一次',
          MMS2100: '二次①',
          MMS2200: '二次②',
          MMS3100: '三次①',
          MMS3200: '三次②',
        },
      },
    },
    lng: 'ja',
    fallbackLng: 'ja',
    interpolation: { escapeValue: false },
  });
}
